import React from 'react';
import ReactDOM from 'react-dom';
import { loadIntlDataForLocale } from 'common/utils/intl';
import { IntlProvider } from 'react-intl';
import Accordion from './components/Accordion';
import ColorSliderApp from 'marketing/components/ColorSliderApp';

document.addEventListener('DOMContentLoaded', () => {
    Accordion.create('[data-accordion]', () => {});
});

var colorSlider = document.querySelector('[data-color-slider]');
const cfg = document.querySelector('[data-color-slider-config]').innerHTML;
const config = JSON.parse(cfg);

if (colorSlider) {
    loadIntlDataForLocale(document.documentElement.lang).then(() => {
        ReactDOM.render(
            <IntlProvider locale={document.documentElement.lang} messages={config.intl.messages}>
                <ColorSliderApp />
            </IntlProvider>,
            colorSlider
        );
    });
}
